<template>
    <div class="mx-2 mx-lg-5">
        <div class="card my-3">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>{{ nfcTag.name }}</h3>
                <div>
                    <button class="btn btn-sm btn-secondary me-3" @click="editNfc">
                        <icon icon="EditPen"></icon>
                    </button>
                    <button class="btn btn-sm btn-danger" @click="deleteNfc">
                        <icon icon="Trash"></icon>
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="row mb-0">
                            <dt class="col-sm-4">{{ $t("nfcTag.patrolRoute") }}</dt>
                            <dd class="col-sm-8">{{ nfcTag.patrol_route_name }}</dd>

                            <dt class="col-sm-4">{{ $t("nfcTag.name") }}</dt>
                            <dd class="col-sm-8">{{ nfcTag.name }}</dd>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="row mb-0">
                            <dt class="col-sm-4">{{ $t("nfcTag.id") }}</dt>
                            <dd class="col-sm-8">{{ nfcTag.uid }}</dd>

                            <dt class="col-sm-4">{{ $t("nfcTag.order") }}</dt>
                            <dd class="col-sm-8">{{ nfcTag.order }}</dd>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-header">
                <h3>Lokace</h3>
            </div>
            <div class="card-body">
                <MapView
                    v-if="nfcTag.latitude != null && nfcTag.longitude != null"
                    :nfcTag="nfcTag"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import { goToEdit, deleteItem } from '@/utils/actions';
import MapView from '@/components/dashboard/MapView.vue';

export default {
    components: {
        Icon,
        MapView,
    },
    data() {
        return {
            nfcTag: {},
        }
    },
    created() {
        this.getNfcTag();
    },
    methods: {
        getNfcTag() {
            this.$store.getters.api.get(`/dashboard/${this.$route.params.slug}/nfc/${this.$route.params.id}`)
            .then(response => {
                this.nfcTag = response.data;
            })
            .catch(error => {
                console.error("Error loading nfc tag.", error);
            });
        },
        editNfc() {
            goToEdit({
                router: this.$router,
                routeName: "NfcTagEditView",
                slug: this.$route.params.slug,
                id: this.$route.params.id
            })
        },
        deleteNfc() {
            deleteItem({
                api: this.$store.getters.api,
                slug: this.$route.params.slug,
                id: this.$route.params.id,
                model: "nfc",
                confirmMessage: this.$t("utils.deleteConfirm", { name: this.nfcTag.name}),
                redirect: "NfcTagListView",
                router: this.$router,
            });
        },
    }
}
</script>